import React from 'react';

const HoverMenuItemSeparator = () => (
    <li className="hover-menu__item-seperator" />
);

export default HoverMenuItemSeparator;
